import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  FormControlLabel,
  FormGroup,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../components/TabPanel";
import {
  getTransactionApCheckRequest,
  getTransactionBillPaymentPayeeAddress,
  getTransactionEft,
  getTransactionJPMorganDetails,
 
} from "../../api/transaction-type";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import CustomFilesNotes from "./Custom/FilesNotes.jsx";
import CustomLinkedBill from "./Custom/LinkedBills.jsx";
import CustomWorkflow from "./Custom/Workflow.jsx";
import { getTransactionDownloadfile } from "../../api/invoice.js";
export default function TransactionTypeCustom() {
  const params = useParams();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  /*----------------End Tabs-----------------*/
  const [rowData, setRowData] = useState([]);
  const [eftData, seteftData] = useState([]);
  const [tax_R_Data, setTax_R_Data] = useState([]);
  const [Billing_Data, setBilling_Data] = useState([]);
  const [jpMorganData, setJpMorganData] = useState([]);
  const [payeeAddData, setPayeeAddData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);
  async function getTransactionDocDetailTableData(limit = 10, offset = 0) {
    setLoading(true);
    try {
      const { data } = await getTransactionApCheckRequest(user.token, {
        tranid: params.docNo,
        limit,
        offset,
        // type: pageDetail.path,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getJPMorganEftData() {
    try {
      const { data } = await getTransactionJPMorganDetails(user.token, {
        id: params.docNo,
      });
      setJpMorganData(data.data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  //   useEffect(() => {
  //     if (user.token && tabIndex === 7) {
  //       getTransactionEftData();
  //     }
  //     if (user.token && tabIndex === 8) {
  //       getJPMorganEftData();
  //     }
  //     if (user.token && tabIndex === 1) {
  //      getTransactionDocBillPaymentPayeeAddData();
  //     }
  //   }, [tabIndex]);

  async function getTransactionEftData() {
    try {
      const { data } = await getTransactionEft(user.token, {
        id: params.docNo,
      });
      seteftData(data.data.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }

  // async function getTransactionbillingData() {
  //   try {
  //     const { data } = await getTransactionVendorBilling(user.token, {
  //       id: params.docNo,
  //     });
  //     setBilling_Data(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //   }
  // }

  async function getTransactionDocBillPaymentPayeeAddData() {
    setLoading(true);
    try {
      const { data } = await getTransactionBillPaymentPayeeAddress(user.token, {
        id: params.docNo,
      });
      setPayeeAddData(data.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  // async function getTransactionVendorBillTaxAndReportingData() {
  //   try {
  //     const { data } = await getTransactionSalesOrderTaxAndReporting(
  //       user.token,
  //       {
  //         id: params.docNo,
  //       }
  //     );
  //     setTax_R_Data(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //   }
  // }
  const getDownloadDocumentById = ( filename) => {
    setPercentComplete(0);

    const options = {
      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );

        console.log(
          "percentage====",
          progressEvent.loaded,
          progressEvent.total
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getTransactionDownloadfile(
      // { id: id },

      options,

      { filename: filename }
    )
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
      })
      .catch((err) => {
        // errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };
  console.log(Billing_Data, "Billing_Data");
  return loading ? (
    <>
      <Typography component="h2" fontWeight={500} className="pageTitle">
        AP Check Request
      </Typography>

      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Approval Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        AP Check Request
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        <span className="para-no">
          <strong>{rowData.transaction_id}</strong>
        </span>
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((el, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={12} md={12}>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">ID</p>
                  <p className="tFormName">{rowData?.transaction_id}</p>
                </Grid>
                {/* <Grid item xs={12} sm={4} md={3} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={<checkbox  disabled/>}
                        label="PAYMENT HOLD"
                      />
                    </FormGroup>
                  </Grid> */}
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">AMOUNT</p>
                  <p className="tFormName">{rowData?.amount}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">INVOICE DATE</p>
                  <p className="tFormName">{rowData?.invoice_date}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">PAYMENT REQUEST STATUS</p>
                  <p className="tFormName">{rowData?.payment_request_status}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">VENDOR</p>
                  <p className="tFormName">{rowData?.vendor_name}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">EXPENSE TYPE</p>
                  <p className="tFormName">{rowData?.expense_type}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">VENDOR INVOICE NUMBER</p>
                  <p className="tFormName">{rowData?.vendor_invoice_number}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">REQUEST DATE</p>
                  <p className="tFormName">{rowData?.request_date}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">PC/PROJECT</p>
                  <p className="tFormName">{rowData?.pc_project}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">GOVT EXP SUBCATEGORY</p>
                  <p className="tFormName">{rowData?.pc_project}</p>
                </Grid>

                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">VENDOR INVOICE ATTACHMENT</p>
                  <Link
                    style={{ color: "#034ea2", border: "2px solid #008cba" }}
                    onClick={() => {
                      setDialogOpen(true);
                      getDownloadDocumentById(rowData?.vendor_invoice_attachment );
                    }}
                  >
                    {rowData?.vendor_invoice_attachment}
                  </Link>
                </Grid>

                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">REQUESTED BY</p>
                  <p className="tFormName">{rowData?.requested_by}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">PROJECT DIRECTOR </p>
                  <p className="tFormName">{rowData?.project_director}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">PROJECT VP</p>
                  <p className="tFormName">{rowData?.project_vp}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">PURPOSE OF CHECK</p>
                  <p className="tFormName">{rowData?.purpose_of_check}</p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">MAILING ADDRESS & INSTRUCTIONS</p>
                  <p className="tFormName">
                    {rowData?.mailing_address_instructions}
                  </p>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <p className="tFormlabel">NEXT APPROVER</p>
                  <p className="tFormName">{rowData?.next_approver}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className="m-b-10">
                  <p className="tFormlabel">PROJECT EVP</p>
                  <p className="tFormName">{rowData?.project_evp}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className="m-b-10"></Grid>

                <Grid item xs={12} sm={3} md={3} className="m-b-10">
                  <p className="tFormlabel">CATEGORY</p>
                  <p className="tFormName">{rowData?.category}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className="m-b-10">
                  <p className="tFormlabel">SUBSIDIARY</p>
                  <p className="tFormName">{rowData?.subsidiary}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className="m-b-10"></Grid>
                <Grid item xs={12} sm={3} md={3} className="m-b-10">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            rowData?.financial_workbook_book_upload === "T"
                          }
                          name="isVpCheckbox"
                        />
                      }
                      label="FINANCIAL WORKBOOK BOOK UPLOAD"
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* ))} */}
        </Box>
      </Box>
      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Approval Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((el, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={4} md={3} className="m-b-10">
              <p className="tFormlabel">STAGE 1 APPROVED BY</p>
              <p className="tFormName">{rowData?.stage1_approved_by}</p>
            </Grid>

            <Grid item xs={12} sm={4} md={3} className="m-b-10">
              <p className="tFormlabel">STAGE 2 APPROVED BY</p>
              <p className="tFormName">{rowData?.stage2_approved_by}</p>
            </Grid>

            <Grid item xs={12} sm={4} md={2} className="m-b-10">
              <p className="tFormlabel">STAGE 3 APPROVED BY</p>
              <p className="tFormName">{rowData?.stage3_approved_by}</p>
            </Grid>

            <Grid item xs={12} sm={3} md={2} className="m-b-10">
              <p className="tFormlabel">REJECTED/VOIDED BY</p>
              <p className="tFormName">{rowData?.rejected_voided_by}</p>
            </Grid>

            <Grid item xs={12} sm={3} md={2} className="m-b-10">
              <p className="tFormlabel">REJECTED/VOIDED DATE</p>
              <p className="tFormName">{rowData?.rejected_date}</p>
            </Grid>

            <Grid item xs={12} sm={4} md={3} className="m-b-10">
              <p className="tFormlabel">STAGE 1 APPROVAL DATE</p>
              <p className="tFormName">{rowData?.stage1_approved_date}</p>
            </Grid>

            <Grid item xs={12} sm={4} md={3} className="m-b-10">
              <p className="tFormlabel">STAGE 2 APPROVAL DATE</p>
              <p className="tFormName">{rowData?.stage2_approved_date}</p>
            </Grid>

            <Grid item xs={12} sm={4} md={3} className="m-b-10">
              <p className="tFormlabel">STAGE 3 APPROVAL DATE</p>
              <p className="tFormName">{rowData?.stage3_approved_date}</p>
            </Grid>

            <Grid item xs={12} sm={3} md={3} className="m-b-10">
              <p className="tFormlabel">REJECT/VOID REASON</p>
              <p className="tFormName">{rowData?.reject_void_reason}</p>
            </Grid>

            {/* <Grid item xs={12} sm={3} md={3} className="m-b-10">
              <p className="tFormlabel">CATEGORY</p>
              <p className="tFormName">{rowData?.category}</p>
            </Grid>
*/}
            <Grid item xs={12} sm={3} md={3} className="m-b-10"></Grid>
            <Grid item xs={12} sm={3} md={3} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rowData?.toBePrinted === "T"}
                      name="isVpCheckbox"
                    />
                  }
                  label="APPROVE AND CLOSE"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={3} md={3} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rowData?.toBePrinted === "T"}
                      name="isVpCheckbox"
                    />
                  }
                  label="IS VP"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Files & Notes" />
            <Tab label="Workflows" />
            <Tab label="Linked Bills" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
            <CustomFilesNotes />
          </TabPanel>
          {/*------------Payee Address------------*/}
          <TabPanel value={tabIndex} index={1}>
            {tabIndex === 1 && <CustomWorkflow />}
          </TabPanel>
          {/* RelatedRecords */}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && <CustomLinkedBill></CustomLinkedBill>}
          </TabPanel>
        </Box>
      </Box>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Download Progress</DialogTitle>
        <DialogContent>
          {downloadInProgress ? (
            <>
              <CircularProgress
                variant="indeterminate"
                value={percentComplete}
                size={50}
                thickness={10}
                style={{ marginLeft: "65px" }}
              />
              <Box
                sx={{
                  marginTop: 2,
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#333",
                  "&:hover": {
                    color: "#1976d2",
                    cursor: "pointer",
                  },
                }}
              >
                <span>Please wait...</span>
              </Box>
            </>
          ) : (
            <></>
          )}
        </DialogContent>
        {/* Add dialog actions here if needed */}
      </Dialog>
    </>
  );
}
